module.exports = __webpack_public_path__ + "static/media/idea_c.36395c02.svg";